import React, { useContext } from 'react';
import { Footer, MenuBar } from '../../layout/welcome';
import { MembershipContext } from '../../context/membership/membership';
import { Link } from "react-router-dom";
import { useHistory, useParams } from "react-router-dom";
import { useQuery } from "../../utils/query-parameter";
import { _retrieveData, _storeData } from "../../utils/local-storage";
import moment from "moment";
import useScrollBarPosition from "../../effect/Scroll";
import { useWindowSize } from "../../effect/WindowSize";
import { authGetRequest, getCourseItemAPI, getRequest } from "../../api/laravel/public/api";
import { HeaderText } from '../../components';
import { StudentCourse } from '../../layout/Dashboard';

const Index = () => {
    const size = useWindowSize();
    const router = useHistory();
    const param = useQuery();
    const { id } = useParams();
    // const { data } = getCourseItemAPI(course);
    const { membership } = useContext(MembershipContext);
    const [user, setUser] = React.useState({});
    // const { user } = useContext(AuthContext);
    const [data, setData] = React.useState({});
    const [isLoading, setLoading] = React.useState(false);
    const [isPageLoader, setPageLoader] = React.useState(false);
    const [tab, setTab] = React.useState(0);
    // const { page, loading } = React.useContext(settingContext);
    const [page, setPage] = React.useState(null);
    const [loading, setLoadingn] = React.useState(false);
    const [modal, setModal] = React.useState(false);
    const playerRef = React.useRef(null);
    const [session, setSession] = React.useState(0);

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    React.useEffect(() => {
        initialApi();
    }, []);

    const initialApi = async () => {
        setPageLoader(true);
        const pageData = await _retrieveData("page_data");
        if (pageData) {
            setPage(pageData);
            setPageLoader(true);
        }
        const { data_r, message, isError, isLoading } = await getRequest(
            `/auth/api/page`
        );
        setPage(data_r);
        setPageLoader(false);
        await _storeData(data_r, "page_data");
    };


    return (
        <div id="page-top" class="home">
            <div id="page-wrap">
                <MenuBar menuIndex="testimonial" setting={page?.setting} loader={isPageLoader} />
                <section className="sub-banner sub-banner-course">
                    <div className="awe-static bg-sub-banner-course" style={{ backgroundImage: 'url(../img/course_banner.jpeg)' }} />
                    <div className="awe-overlay" />
                    <div className="container">
                        <div className="sub-banner-content">
                            <h1 className="text-center text-white font-bold text-5xl">Testimonial</h1>
                        </div>
                    </div>
                </section>
                <section className="course-top my-6">
                    <div className="container">
                        <div className="grid mb-8 lg:mb-12 lg:grid-cols-2">
                            {page?.testimony?.map((item, index) => (
                                <figure key={index} className="flex flex-col justify-center items-center p-8 text-center bg-gray-50 border-b border-gray-200 md:p-12 lg:border-r dark:border-gray-700">
                                    <blockquote className="mx-auto mb-8 max-w-2xl text-gray-500 dark:text-gray-400">
                                        {/* <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Speechless with how easy this was to integrate</h3> */}
                                        <p className="my-4">"{item.description}".</p>
                                    </blockquote>
                                    <figcaption className="flex justify-center items-center space-x-3">
                                        <img className="w-9 h-9 rounded-full" src={process.env.REACT_APP_LOCAL_FILE_PATH + "page/large/" + item.image} alt="profile picture" />
                                        <div className="space-y-0.5 font-medium dark:text-white text-left">
                                            <div className='black bold'>{item.header}</div>
                                            <div className="text-sm font-light text-gray-500 dark:text-gray-400">{item.title}</div>
                                        </div>
                                    </figcaption>
                                </figure>
                            ))}
                        </div>
                    </div>
                </section>
                <Footer setting={page?.setting} />
            </div>
        </div>
    );
};

export default Index;